import {
  StyledCombobox
} from "./chunk-WRCT55VA.mjs";
import {
  ErrorFilled_default
} from "./chunk-EOMCCNMZ.mjs";
import {
  ChevronDown_default
} from "./chunk-LRTFI6YS.mjs";

// src/components/combobox/combobox-input.tsx
import React, { forwardRef } from "react";
var ComboboxInput = forwardRef(function ComboboxInput2(props, ref) {
  return /* @__PURE__ */ React.createElement(StyledCombobox.Control, { ...props }, /* @__PURE__ */ React.createElement(StyledCombobox.Input, null), /* @__PURE__ */ React.createElement(StyledCombobox.TriggerGroup, null, /* @__PURE__ */ React.createElement(StyledCombobox.ClearTrigger, null, /* @__PURE__ */ React.createElement(ErrorFilled_default, null)), /* @__PURE__ */ React.createElement(StyledCombobox.Trigger, { ref }, /* @__PURE__ */ React.createElement(ChevronDown_default, null))));
});

export {
  ComboboxInput
};
